<template>
  <Form 
    :d_form='form'
    :d_aiman='aiman'
    v-if="id > 0 && load == 2"
  /> 

<Form 
    :d_form='form'
    :d_aiman='aiman'
    v-else-if="id == 0 && load == 1"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'tangki.pengagihan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        // { label: 'Daftar Tangki LN2', route: '/tangki' },
        { label: 'Pengagihan', route: '/tangki/pengagihan' },
      ],
      title : 'Pengagihan',
      form : {
        id : 0,
        tarikh : '',
        isipadu : '',
        pemohon_id : '',
        penerima_id : '',
        no_pagihan : '',
        hantar: 2
        
      },
      tarikh : [],
      no_tangki : [],
      isipadu : [],
      pemohon_id : [],
      penerima_id : [],
      no_pagihan : [],
      aiman:[],
      load : 0
      
      
    }
  },
  methods: {
    

    getAiman(){
      this.$zcomm.get(this.api_service + 'lookup/aiman', {}).then(res => {
        this.aiman = res
        this.load = this.load + 1
      })
    },
 
     getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'tangki_pengagihan/show/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1

        })
      }
    },
  
  },

  watch: {

  },
  mounted() {
    this.getAiman()
    this.getData()
    
  }
    
}
</script>
